import { Chart } from "chart.js";
import "./CrmPieChart.css";
import React, { useEffect, useRef, useState } from "react";
import { formatNumberWithSpaces } from "../../../../utils/Utils";

function CrmPieChart({ labels = [], datasets = [], percentages = [] }) {
  const canvasRef = useRef(null);
  const previousStyle = useRef({ labels: null, datasets: null });
  const rootStyle = getComputedStyle(document.documentElement);
  const [chart, setChart] = useState(null);

  const defaultFont = {
    family: "Outfit",
    size: 14,
  };

  useEffect(() => {
    if (
      JSON.stringify(previousStyle.current.labels) === JSON.stringify(labels) &&
      JSON.stringify(previousStyle.current.datasets) === JSON.stringify(datasets)
    )
      return;

    if (chart) chart.destroy();

    previousStyle.current = { labels, datasets };
    const finalDatasets = datasets.map(dataset => ({
      ...dataset,
      backgroundColor: translateColors(dataset),
    }));

    const chartConfig = {
      type: "pie",
      data: {
        labels: labels,
        datasets: finalDatasets,
      },
      options: {
        responsive: true,
        plugins: {
          tooltip: {
            titleFont: defaultFont,
            bodyFont: defaultFont,
            titleMarginBottom: 8,
            boxPadding: 5,
          },
          legend: {
            display: true,
            position: "right",
            labels: {
              boxWidth: 35,
              padding: 15,
              font: defaultFont,
              generateLabels: chart => {
                const data = chart.data;
                const dataset = data.datasets[0];

                return data.labels
                  .map((label, index) => ({
                    text: `${label} (${formatNumberWithSpaces(dataset.data[index], true)} - ${percentages[index]})`,
                    fillStyle: dataset.backgroundColor[index],
                    strokeStyle: dataset.backgroundColor[index],
                    lineWidth: 1,
                    hidden: false,
                    index: index,
                    value: dataset.data[index],
                  }))
                  .sort((label, prev) => prev.value - label.value, { value: 0 });
              },
            },
          },
        },
      },
    };

    setChart(new Chart(canvasRef.current, chartConfig));
  }, [labels, datasets]);

  function translateColors(dataset) {
    const finalColors = [];
    dataset.backgroundColor.forEach(color => {
      if (color?.includes("--")) finalColors.push(rootStyle.getPropertyValue(color).trim());
      else finalColors.push(color);
    });

    return finalColors;
  }

  return (
    <div className='crm-doughnut-chart-container'>
      <canvas ref={canvasRef} style={{ maxWidth: "650px", maxHeight: "350px" }} />
    </div>
  );
}

export default CrmPieChart;
